import RedirectToViewer from "./RedirectToViewer";

export default RedirectToViewer;